import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// Inter, self-hosted (the CSP only allows fonts from our own origin).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
